export function aiChatLifecycleError(error) {
 const data=error?.response?.data || error || {},code=data.error?.code || data.code;
 const messages={ AI_CHAT_INCOGNITO:"Incognito chats can't be archived or restored.", AI_CHAT_INCOGNITO_IMMUTABLE:"A chat's incognito setting can't be changed after it starts.", AI_CHAT_NOT_INCOGNITO:"Only an incognito chat can be ended. Your saved chat has been kept.", AI_CHAT_NOT_FOUND:'This AI chat is no longer available.' };
 return messages[code] || 'Could not complete this AI request. Please try again.';
}
